__turbopack_context__.v({
  "blogsecCard": "BlogSec1-module__9QGv7W__blogsecCard",
  "blogsecContainer": "BlogSec1-module__9QGv7W__blogsecContainer",
  "blogsecGrid": "BlogSec1-module__9QGv7W__blogsecGrid",
  "blogsecIconImg": "BlogSec1-module__9QGv7W__blogsecIconImg",
  "blogsecIconWrap": "BlogSec1-module__9QGv7W__blogsecIconWrap",
  "blogsecTitle": "BlogSec1-module__9QGv7W__blogsecTitle",
});
